import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Productfullwidth() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <nav aria-label="breadcrumb" className="breadcrumb-nav border-0 mb-0">
    <div className="container-fluid d-flex align-items-center">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><a href="index.html">Home</a></li>
        <li className="breadcrumb-item"><a href="#">Products</a></li>
        <li className="breadcrumb-item active" aria-current="page">Fullwidth</li>
      </ol>
      <nav className="product-pager ml-auto" aria-label="Product">
        <a className="product-pager-link product-pager-prev" href="#" aria-label="Previous" tabIndex={-1}>
          <i className="icon-angle-left" />
          <span>Prev</span>
        </a>
        <a className="product-pager-link product-pager-next" href="#" aria-label="Next" tabIndex={-1}>
          <span>Next</span>
          <i className="icon-angle-right" />
        </a>
      </nav>{/* End .pager-nav */}
    </div>{/* End .container-fluid */}
  </nav>{/* End .breadcrumb-nav */}
  <div className="page-content">
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-10">
          <div className="product-details-top">
            <div className="row">
              <div className="col-md-6 col-lg-7">
                <div className="product-gallery">
                  <figure className="product-main-image">
                    <span className="product-label label-sale">Sale</span>
                    <img id="product-zoom" src="asset/images/products/single/fullwidth/3.jpg" data-zoom-image="asset/images/products/single/fullwidth/3-big.jpg" alt="product image" />
                    <a href="#" id="btn-product-gallery" className="btn-product-gallery">
                      <i className="icon-arrows" />
                    </a>
                  </figure>{/* End .product-main-image */}
                  <div id="product-zoom-gallery" className="product-image-gallery max-col-6">
                    <a className="product-gallery-item" href="#" data-image="asset/images/products/single/fullwidth/1.jpg" data-zoom-image="asset/images/products/single/fullwidth/1-big.jpg">
                      <img src="asset/images/products/single/fullwidth/1-small.jpg" alt="product side" />
                    </a>
                    <a className="product-gallery-item" href="#" data-image="asset/images/products/single/fullwidth/2.jpg" data-zoom-image="asset/images/products/single/fullwidth/2-big.jpg">
                      <img src="asset/images/products/single/fullwidth/2-small.jpg" alt="product cross" />
                    </a>
                    <a className="product-gallery-item active" href="#" data-image="asset/images/products/single/fullwidth/3.jpg" data-zoom-image="asset/images/products/single/fullwidth/3-big.jpg">
                      <img src="asset/images/products/single/fullwidth/3-small.jpg" alt="product with model" />
                    </a>
                    <a className="product-gallery-item" href="#" data-image="asset/images/products/single/fullwidth/4.jpg" data-zoom-image="asset/images/products/single/fullwidth/4-big.jpg">
                      <img src="asset/images/products/single/fullwidth/4-small.jpg" alt="product back" />
                    </a>
                  </div>{/* End .product-image-gallery */}
                </div>{/* End .product-gallery */}
              </div>{/* End .col-lg-7 */}
              <div className="col-md-6 col-lg-5">
                <div className="product-details">
                  <h1 className="product-title">Beige ring handle circle cross body bag</h1>{/* End .product-title */}
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <a className="ratings-text" href="#product-accordion" id="review-link">( 2 Reviews )</a>
                  </div>{/* End .rating-container */}
                  <div className="product-price">
                    <span className="new-price">$56.00</span>
                    <span className="old-price">$110.00</span>
                  </div>{/* End .product-price */}
                  <div className="product-content">
                    <p>Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero eu augue. Morbi purus libero, faucibus adipiscing. Sed lectus. </p>
                  </div>{/* End .product-content */}
                  <div className="details-filter-row details-row-size">
                    <label>Color:</label>
                    <div className="product-nav product-nav-thumbs">
                      <a href="#" className="active">
                        <img src="asset/images/products/single/fullwidth/1-thumb.jpg" alt="product desc" />
                      </a>
                      <a href="#">
                        <img src="asset/images/products/single/fullwidth/2-thumb.jpg" alt="product desc" />
                      </a>
                      <a href="#">
                        <img src="asset/images/products/single/fullwidth/3-thumb.jpg" alt="product desc" />
                      </a>
                      <a href="#">
                        <img src="asset/images/products/single/fullwidth/4-thumb.jpg" alt="product desc" />
                      </a>
                    </div>{/* End .product-nav */}
                  </div>{/* End .details-filter-row */}
                  <div className="details-filter-row details-row-size">
                    <label htmlFor="size">Size:</label>
                    <div className="select-custom">
                      <select name="size" id="size" className="form-control">
                        <option value="#" selected="selected">Select a size</option>
                        <option value="s">Small</option>
                        <option value="m">Medium</option>
                        <option value="l">Large</option>
                        <option value="xl">Extra Large</option>
                      </select>
                    </div>{/* End .select-custom */}
                  </div>{/* End .details-filter-row */}
                  <div className="details-filter-row details-row-size">
                    <label htmlFor="qty">Qty:</label>
                    <div className="product-details-quantity">
                      <input type="number" id="qty" className="form-control" defaultValue={1} min={1} max={10} step={1} data-decimals={0} required />
                    </div>{/* End .product-details-quantity */}
                  </div>{/* End .details-filter-row */}
                  <div className="product-details-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <div className="details-action-wrapper">
                      <a href="#" className="btn-product btn-wishlist" title="Wishlist"><span>Add to Wishlist</span></a>
                      <a href="#" className="btn-product btn-compare" title="Compare"><span>Add to Compare</span></a>
                    </div>{/* End .details-action-wrapper */}
                  </div>{/* End .product-details-action */}
                  <div className="product-details-footer">
                    <div className="product-cat">
                      <span>Category:</span>
                      <a href="#">Women</a>,
                      <a href="#">Dresses</a>,
                      <a href="#">Yellow</a>
                    </div>{/* End .product-cat */}
                    <div className="social-icons social-icons-sm">
                      <span className="social-label">Share:</span>
                      <a href="#" className="social-icon" title="Facebook" target="_blank"><i className="icon-facebook-f" /></a>
                      <a href="#" className="social-icon" title="Twitter" target="_blank"><i className="icon-twitter" /></a>
                      <a href="#" className="social-icon" title="Instagram" target="_blank"><i className="icon-instagram" /></a>
                      <a href="#" className="social-icon" title="Pinterest" target="_blank"><i className="icon-pinterest" /></a>
                    </div>
                  </div>{/* End .product-details-footer */}
                  <div className="accordion accordion-plus product-details-accordion" id="product-accordion">
                    <div className="card card-box card-sm">
                      <div className="card-header" id="product-desc-heading">
                        <h2 className="card-title">
                          <a className="collapsed" role="button" data-toggle="collapse" href="#product-accordion-desc" aria-expanded="false" aria-controls="product-accordion-desc">
                            Description
                          </a>
                        </h2>
                      </div>{/* End .card-header */}
                      <div id="product-accordion-desc" className="collapse" aria-labelledby="product-desc-heading" data-parent="#product-accordion">
                        <div className="card-body">
                          <div className="product-desc-content">
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis. Suspendisse urna viverra non, semper suscipit, posuere a, pede. Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci.</p>
                            <ul>
                              <li>Nunc nec porttitor turpis. In eu risus enim. In vitae mollis elit. </li>
                              <li>Vivamus finibus vel mauris ut vehicula.</li>
                              <li>Nullam a magna porttitor, dictum risus nec, faucibus sapien.</li>
                            </ul>
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis. Suspendisse urna viverra non, semper suscipit, posuere a, pede.</p>
                          </div>{/* End .product-desc-content */}
                        </div>{/* End .card-body */}
                      </div>{/* End .collapse */}
                    </div>{/* End .card */}
                    <div className="card card-box card-sm">
                      <div className="card-header" id="product-info-heading">
                        <h2 className="card-title">
                          <a className="collapsed" role="button" data-toggle="collapse" href="#product-accordion-info" aria-expanded="false" aria-controls="product-accordion-info">
                            Additional Information
                          </a>
                        </h2>
                      </div>{/* End .card-header */}
                      <div id="product-accordion-info" className="collapse" aria-labelledby="product-info-heading" data-parent="#product-accordion">
                        <div className="card-body">
                          <div className="product-desc-content">
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis. Suspendisse urna viverra non, semper suscipit, posuere a, pede. Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci. </p>
                            <h3>Fabric &amp; care</h3>
                            <ul>
                              <li>100% Polyester</li>
                              <li>Do not iron</li>
                              <li>Do not wash</li>
                              <li>Do not bleach</li>
                              <li>Do not tumble dry</li>
                              <li>Professional dry clean only</li>
                            </ul>
                            <h3>Size</h3>
                            <p>S, M, L, XL</p>
                          </div>{/* End .product-desc-content */}
                        </div>{/* End .card-body */}
                      </div>{/* End .collapse */}
                    </div>{/* End .card */}
                    <div className="card card-box card-sm">
                      <div className="card-header" id="product-shipping-heading">
                        <h2 className="card-title">
                          <a className="collapsed" role="button" data-toggle="collapse" href="#product-accordion-shipping" aria-expanded="false" aria-controls="product-accordion-shipping">
                            Shipping &amp; Returns
                          </a>
                        </h2>
                      </div>{/* End .card-header */}
                      <div id="product-accordion-shipping" className="collapse" aria-labelledby="product-shipping-heading" data-parent="#product-accordion">
                        <div className="card-body">
                          <div className="product-desc-content">
                            <p>We deliver to over 100 countries around the world. For full details of the delivery options we offer, please view our <a href="#">Delivery information</a><br />
                              We hope you’ll love every purchase, but if you ever need to return an item you can do so within a month of receipt. For full details of how to make a return, please view our <a href="#">Returns information</a></p>
                          </div>{/* End .product-desc-content */}
                        </div>{/* End .card-body */}
                      </div>{/* End .collapse */}
                    </div>{/* End .card */}
                    <div className="card card-box card-sm">
                      <div className="card-header" id="product-review-heading">
                        <h2 className="card-title">
                          <a role="button" data-toggle="collapse" href="#product-accordion-review" aria-expanded="true" aria-controls="product-accordion-review">
                            Reviews (2)
                          </a>
                        </h2>
                      </div>{/* End .card-header */}
                      <div id="product-accordion-review" className="collapse show" aria-labelledby="product-review-heading" data-parent="#product-accordion">
                        <div className="card-body">
                          <div className="reviews">
                            <div className="review">
                              <div className="row no-gutters">
                                <div className="col-auto">
                                  <h4><a href="#">Samanta J.</a></h4>
                                  <div className="ratings-container">
                                    <div className="ratings">
                                      <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                                    </div>{/* End .ratings */}
                                  </div>{/* End .rating-container */}
                                  <span className="review-date">6 days ago</span>
                                </div>{/* End .col */}
                                <div className="col">
                                  <h4>Good, perfect size</h4>
                                  <div className="review-content">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus cum dolores assumenda asperiores facilis porro reprehenderit animi culpa atque blanditiis commodi perspiciatis doloremque, possimus, explicabo, autem fugit beatae quae voluptas!</p>
                                  </div>{/* End .review-content */}
                                  <div className="review-action">
                                    <a href="#"><i className="icon-thumbs-up" />Helpful (2)</a>
                                    <a href="#"><i className="icon-thumbs-down" />Unhelpful (0)</a>
                                  </div>{/* End .review-action */}
                                </div>{/* End .col-auto */}
                              </div>{/* End .row */}
                            </div>{/* End .review */}
                            <div className="review">
                              <div className="row no-gutters">
                                <div className="col-auto">
                                  <h4><a href="#">John Doe</a></h4>
                                  <div className="ratings-container">
                                    <div className="ratings">
                                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                                    </div>{/* End .ratings */}
                                  </div>{/* End .rating-container */}
                                  <span className="review-date">5 days ago</span>
                                </div>{/* End .col */}
                                <div className="col">
                                  <h4>Very good</h4>
                                  <div className="review-content">
                                    <p>Sed, molestias, tempore? Ex dolor esse iure hic veniam laborum blanditiis laudantium iste amet. Cum non voluptate eos enim, ab cumque nam, modi, quas iure illum repellendus, blanditiis perspiciatis beatae!</p>
                                  </div>{/* End .review-content */}
                                  <div className="review-action">
                                    <a href="#"><i className="icon-thumbs-up" />Helpful (0)</a>
                                    <a href="#"><i className="icon-thumbs-down" />Unhelpful (0)</a>
                                  </div>{/* End .review-action */}
                                </div>{/* End .col-auto */}
                              </div>{/* End .row */}
                            </div>{/* End .review */}
                          </div>{/* End .reviews */}
                        </div>{/* End .card-body */}
                      </div>{/* End .collapse */}
                    </div>{/* End .card */}
                  </div>{/* End .accordion */}
                </div>{/* End .product-details */}
              </div>{/* End .col-lg-5 */}
            </div>{/* End .row */}
          </div>{/* End .product-details-top */}
        </div>{/* End .col-xl-10 */}
        <aside className="col-xl-2 d-md-none d-xl-block">
          <div className="sidebar sidebar-product">
            <div className="widget widget-products">
              <h4 className="widget-title">Related Product</h4>{/* End .widget-title */}
              <div className="products">
                <div className="product product-sm">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/products/single/sidebar/1.jpg" alt="Product image" className="product-image" />
                    </a>
                  </figure>
                  <div className="product-body">
                    <h5 className="product-title"><a href="product.html">Light brown studded <br />Wide fit wedges</a></h5>{/* End .product-title */}
                    <div className="product-price">
                      <span className="new-price">$50.00</span>
                      <span className="old-price">$110.00</span>
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product product-sm */}
                <div className="product product-sm">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/products/single/sidebar/2.jpg" alt="Product image" className="product-image" />
                    </a>
                  </figure>
                  <div className="product-body">
                    <h5 className="product-title"><a href="product.html">Yellow button front tea top</a></h5>{/* End .product-title */}
                    <div className="product-price">
                      $56.00
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product product-sm */}
                <div className="product product-sm">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/products/single/sidebar/3.jpg" alt="Product image" className="product-image" />
                    </a>
                  </figure>
                  <div className="product-body">
                    <h5 className="product-title"><a href="product.html">Beige metal hoop tote bag</a></h5>{/* End .product-title */}
                    <div className="product-price">
                      $50.00
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product product-sm */}
                <div className="product product-sm">
                  <figure className="product-media">
                    <a href="product.html">
                      <img src="asset/images/products/single/sidebar/4.jpg" alt="Product image" className="product-image" />
                    </a>
                  </figure>
                  <div className="product-body">
                    <h5 className="product-title"><a href="product.html">Black soft RI weekend <br />travel bag</a></h5>{/* End .product-title */}
                    <div className="product-price">
                      $75.00
                    </div>{/* End .product-price */}
                  </div>{/* End .product-body */}
                </div>{/* End .product product-sm */}
              </div>{/* End .products */}
              <a href="category.html" className="btn btn-outline-dark-3"><span>View More Products</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .widget widget-products */}
            <div className="widget widget-banner-sidebar">
              <div className="banner-sidebar-title">ad box 280 x 280</div>{/* End .ad-title */}
              <div className="banner-sidebar banner-overlay">
                <a href="#">
                  <img src="asset/images/blog/sidebar/banner.jpg" alt="banner" />
                </a>
              </div>{/* End .banner-ad */}
            </div>{/* End .widget */}
          </div>{/* End .sidebar sidebar-product */}
        </aside>{/* End .col-xl-2 */}
      </div>{/* End .row */}
    </div>{/* End .container-fluid */}
  </div>{/* End .page-content */}
</main>

        <UserFooter/>

    </div>
  )
}

export default Productfullwidth